import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "reactstrap";
import CBRELogo from "../images/cbre-logo.svg";
import CNNLogo from "../images/cnn-logo.svg";
import DellLogo from "../images/dell-logo.svg";
import JohnsonAndJohnsonLogo from "../images/johnsonandjohnson-logo.svg";
import MarriottLogo from "../images/marriott-logo.svg";
import MetLifeLogo from "../images/metlife-logo.svg";
import MicrosoftLogo from "../images/microsoft-logo.svg";
import NBCLogo from "../images/nbc-logo.svg";
import PepsiLogo from "../images/pepsi-logo.svg";
import UniversalLogo from "../images/universal-logo.svg";
import LandingPageCarouselBig from "../Components/Landing/LandingPageCarouselBig";
import LandingPageCarouselSmall from "../Components/Landing/LandingPageCarouselSmall";
import TitleAndMetaTags from "../Components/Common/TitleAndMetaTags";
import { scrollToElement, parseQuerystring } from "../Code/Utilities";
import { SetPreSelectedCharityIdApi, LandingPageHit } from "../Code/Data";
import PurchaseItems from "../Components/Common/PurchaseItems";
import $ from "jquery";

export default class LandingPage extends Component {
  constructor(props) {
    super(props);
    LandingPageHit(parseQuerystring(window.location.search));
  }

  componentDidMount() {
    const qsVariables = parseQuerystring(window.location.search),
      preselectedCharityId = qsVariables.CID;
    if (preselectedCharityId) {
      SetPreSelectedCharityIdApi(preselectedCharityId);
    }
    if (window.location.hash.toLowerCase().includes("#givegiftcards")) {
      const navHeight = $(".navbar")[0].offsetHeight;
      setTimeout(() => {
        scrollToElement(".stepWay", true, navHeight);
      }, 1000);
    } else if (window.location.hash.toLowerCase().includes("#sitemap")) {
      const navHeight = $(".navbar")[0].offsetHeight;
      setTimeout(() => {
        scrollToElement(".sitemap", true, navHeight);
      }, 1000);
    }
  }
  giveGift = () => {
    const navHeight = $(".navbar")[0].offsetHeight;
    scrollToElement(".stepWay", true, navHeight);
  };

  render() {
    if (window.location.hash.toLowerCase().includes("#givegiftcards")) {
      setTimeout(() => requestAnimationFrame(this.giveGift), 1000);
    }
    return (
      <Fragment>
        <TitleAndMetaTags pageName="homepage" />
        <section className="landing-hero">
          <Container fluid>
            <Row>
              <Col xs="12" className="mt-md text-center">
                <h5>
                  <em>
                    COVID-19: Help charities assisting with aid during this time
                    of crisis. <Link to="/Covid19">Learn more</Link> ...
                    <br />
                    <br />
                    <em>
                      Offer for an Economical way to keep in touch with all of
                      your friends and clients.
                    </em>{" "}
                    <a href="/Purchase/BulkDiscount/">Learn more</a> ...
                  </em>
                </h5>
              </Col>
              <Col xs="12" className="mt-md mb-4 text-center">
                <h1>When meaningful matters, give a charity gift card.</h1>
                <h5>
                  <em>Keeping in touch during these challenging times ...</em>
                </h5>
              </Col>
              <Col
                xs="12"
                md={{ size: 8, offset: 2 }}
                className="mb-4 text-center">
                <h3>
                  CharityChoice gifts are donations that you make on another's
                  behalf.
                  <br />
                  The recipient receives a gift card, which empowers them to
                  "spend" on the charity of their choice.
                  <br />
                  <em className="display-5">More purpose, less stuff ...</em>
                </h3>
              </Col>
              <Col
                xs="12"
                className="mb-5 buy-now-button text-center justify-content-center">
                <Button
                  color="primary"
                  className="d-none d-md-block"
                  onClick={this.giveGift}>
                  Give Gift Cards
                </Button>
                <Button
                  color="primary"
                  block
                  className="d-md-none"
                  onClick={this.giveGift}>
                  Give Gift Cards
                </Button>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Container fluid>
            <Row className="section-title-row">
              <Col xs="12" className="text-center stepWay">
                <h2>Ways To Give</h2>
              </Col>
            </Row>
            <Col
              xs="12"
              md={{ size: 8, offset: 2 }}
              className="text-center mb-5">
              <p>
                Our charity gift cards feature a wide selection of beautiful
                designs and are the perfect gift - a gift with a purpose - for
                birthdays, holidays, sympathy, thank you, or any occasion. And
                with over 1000 charities to choose from, everyone can find a
                worthwhile cause 'close to their heart'.
              </p>
            </Col>
            <PurchaseItems />
          </Container>
        </section>
        <section>
          <Container fluid className="corporate">
            <Row className="corp-row">
              <Col xs="12" className="section-title-row text-center">
                <h2>Corporate Solutions</h2>
              </Col>
              <Col xs="12" className="mb-4 text-center">
                <h3 className="mb-4">
                  Business Gifts, Promotions, Events and Employee Recognition
                </h3>
              </Col>
              <Col
                xs="12"
                md={{ size: 8, offset: 2 }}
                className="mb-4 text-center justify-content-center">
                <p>
                  "Giving Back" presents a positive image of social
                  responsibility for your company (CSR) and a boost for employee
                  morale.
                  <br />
                  Corporate clients can enjoy a FREE custom redemption landing
                  page, with a curated custom charity list.
                  <br />
                  You can create eGifts with your own unique graphic design or
                  order bulk, custom gift cards.
                </p>
                <p>
                  Our customization suite gives outstanding branding throughout
                  the user experience - your brand is presented 'front and
                  center'.
                  <br />
                  The most reasonably priced and robust customization in the
                  industry!
                </p>
              </Col>
              <Col
                xs="12"
                md={{ size: 3, offset: 3 }}
                className="mb-4 text-center justify-content-center">
                <Link to="/CorporateSolutions">
                  <Button color="primary" className="d-none d-md-block">
                    Learn More
                  </Button>
                </Link>
                <Link to="/CorporateSolutions">
                  <Button color="primary" block className="d-md-none">
                    Learn More
                  </Button>
                </Link>
              </Col>
              <Col
                xs="12"
                md={{ size: 3 }}
                className="mb-4 text-center justify-content-center">
                <a href="/Login.aspx?CA=1">
                  <Button color="primary" className="d-none d-md-block">
                    Corporate Sign Up
                  </Button>
                </a>
                <a href="/Login.aspx?CA=1">
                  <Button color="primary" block className="d-md-none">
                    Corporate Sign Up
                  </Button>
                </a>
              </Col>
              <Row className="justify-content-center landing-corporate-logo-container">
                <Col xs="12" className="mt-4 mb-2 text-center">
                  <h2>Our Corporate Clients</h2>
                </Col>
                <Col xs="auto">
                  <img
                    src={CBRELogo}
                    alt="CharityChoice corporate client CBRE logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={CNNLogo}
                    alt="CharityChoice corporate client CNN logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={DellLogo}
                    alt="CharityChoice corporate client Dell logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={JohnsonAndJohnsonLogo}
                    alt="Swag bag-goodie bag-giveaway-virtual event-attendees. CharityChoice corporate client Johnson And Johnson logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={MarriottLogo}
                    alt="CharityChoice corporate client Marriott logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={MetLifeLogo}
                    alt="CharityChoice corporate client MetLife logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={MicrosoftLogo}
                    alt="Branded business gifts. Corporate Social Responsibility (CSR), cause affinity, customer loyalty, improve employee motivation and morale."
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={NBCLogo}
                    alt="CharityChoice corporate client NBC logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={PepsiLogo}
                    alt="CharityChoice corporate client Pepsi logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
                <Col xs="auto">
                  <img
                    src={UniversalLogo}
                    alt="CharityChoice corporate client Universal logo"
                    className="landing-page-corporate-logos"
                  />
                </Col>
              </Row>
            </Row>
          </Container>
          <Container fluid className="p-0 charities">
            <Row>
              <Col xs="12" className="section-title-row text-center">
                <h2>Our Charities</h2>
              </Col>
              <Row className="charity-padding-fix-bc-carousel">
                <Col
                  xs="12"
                  md={{ size: 8, offset: 2 }}
                  className="mb-4 text-center justify-content-center">
                  <p>
                    CharityChoice gift card recipients can choose from among
                    over 1000 registered charities, including 250 of the largest
                    national and global charities. Whether the organization your
                    recipient wishes to support is international, national, or
                    just right around the corner, you will know that your gift
                    will go towards a cause dear to them. Participating
                    charities enjoy exposure and discovery on our national
                    platform and are not charged a fee to be listed.
                  </p>
                </Col>
                <Col
                  xs="12"
                  md={{ size: 4, offset: 2 }}
                  className="mb-4 text-center justify-content-center">
                  <a href="/Charities.aspx">
                    <Button color="primary" className="d-none d-md-block">
                      Search Charities
                    </Button>
                  </a>
                  <a href="/Charities.aspx">
                    <Button color="primary" block className="d-md-none">
                      Search Charities
                    </Button>
                  </a>
                </Col>
                <Col
                  xs="12"
                  md={{ size: 4 }}
                  className="mb-4 text-center justify-content-center">
                  <a href="/">
                    <Button color="primary" className="d-none d-md-block">
                      Charity Sign Up
                    </Button>
                  </a>
                  <a href="/AddNatLocalCharitiesRegistration/">
                    <Button color="primary" block className="d-md-none">
                      Charity Sign Up
                    </Button>
                  </a>
                </Col>
              </Row>
            </Row>
            <Row>
              <Col
                xs="12"
                md={{ size: 6, offset: 3 }}
                className="mb-4 text-center justify-content-center">
                <h3>
                  Since 2004, we have helped raise millions of dollars for
                  causes like these:
                </h3>
              </Col>
              <Col xs="12" className="d-md-none">
                <LandingPageCarouselSmall />
              </Col>
              <Col xs="12" className="d-none d-md-block">
                <LandingPageCarouselBig />
              </Col>
            </Row>
          </Container>
        </section>
      </Fragment>
    );
  }
}
